import { createAction, props } from '@ngrx/store';
import { IError } from '../state/app.state';
import { ICategoriesData } from '@app/@shared/Models/all-categories.model';

export const BeginGetAllCategoriesItems = createAction('[CATEGORY] - GET CATEGORY INIT');
export const AllCategoriesSuccess = createAction('[CATEGORY] - GET CATEGORY SUCCESS', props<{ payload: ICategoriesData }>());
export const AllCategoriesError = createAction('[CATEGORY] - GET CATEGORY ERROR', props<{ payload: IError }>());